import { render, staticRenderFns } from "./AnswerCheckbox.vue?vue&type=template&id=43e566a5&"
import script from "./AnswerCheckbox.vue?vue&type=script&lang=js&"
export * from "./AnswerCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports